const isServer = typeof window === 'undefined'

const base64Encode = (value: string) => {
  if (isServer) {
    return Buffer.from(value, 'utf-8').toString('base64')
  }
  return window.btoa(value)
}

const base64Decode = (value: string) => {
  if (isServer) {
    return Buffer.from(value, 'base64').toString('utf-8')
  }
  return window.atob(value)
}

export const encodePhoneQueryValue = (value?: string | null) => {
  if (!value) return null
  const trimmed = value.trim()
  if (!trimmed) return null

  try {
    const normalized = encodeURIComponent(trimmed)
    return base64Encode(normalized)
  } catch (error) {
    console.error('Failed to encode query value', error)
    return null
  }
}

export const decodePhoneQueryValue = (value?: string | string[] | null) => {
  if (!value || (Array.isArray(value) && value.length === 0)) return ''
  const candidate = Array.isArray(value) ? value[0] : value

  try {
    const decoded = decodeURIComponent(base64Decode(candidate))
    return decoded
  } catch (error) {
    // Fall back to the original value for old, non-encoded URLs
    return candidate
  }
}

export const encodePhoneParamInQueryString = (queryString?: string) => {
  if (!queryString) return ''
  const params = new URLSearchParams(queryString)
  const phoneParam = params.get('phone')

  if (!phoneParam) {
    return params.toString()
  }

  const encodedPhone = encodePhoneQueryValue(phoneParam)
  if (encodedPhone) {
    params.set('phone', encodedPhone)
  } else {
    params.delete('phone')
  }

  const encodedQueryString = params.toString()
  return encodedQueryString
}
